// extracted by mini-css-extract-plugin
export default {"cardNoPadding":"DocumentManagerTabItem_cardNoPadding__E1Ao8","searchBarContainer":"DocumentManagerTabItem_searchBarContainer__0KUXg"};